/**
 * Query rules for the task drawer. A task deleted elsewhere answers 404,
 * which no retry fixes, so the drawer closes on the first one.
 */

import { httpStatusOf } from "@/core/http/HttpError";

/** The app default (`core/queryClient.ts`, `retry: 2`). */
const MAX_RETRIES = 2;

export function isNotFound(error: unknown): boolean {
  return httpStatusOf(error) === 404;
}

export function retryUnlessNotFound(failureCount: number, error: unknown): boolean {
  return !isNotFound(error) && failureCount < MAX_RETRIES;
}
